import React from "react";
import { AutoComplete } from "antd";
import { UNIT_OPTIONS } from "./constants";

/**
 * Unit for a part or service. Suggested values can be picked, or the user
 * can type any other unit.
 */
export default function UnitInput(props) {
  return (
    <AutoComplete
      options={UNIT_OPTIONS.map((value) => ({ value }))}
      filterOption={(input, option) =>
        (option.value || "")
          .toLowerCase()
          .includes((input || "").toLowerCase())
      }
      placeholder="Monthly, Weekly, Yearly, Per Device"
      {...props}
    />
  );
}
